import { render, staticRenderFns } from "./verticalBar.vue?vue&type=template&id=7e89dd68&scoped=true&"
var script = {}
import style0 from "./verticalBar.vue?vue&type=style&index=0&id=7e89dd68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e89dd68",
  null
  
)

export default component.exports